<template>
  <page-layout no-padding-top class="contents">

    <display-container :section="411" no-auto-link class="title">
      <template v-slot="{ component, row }">
        <div class="title_top">
          <p>{{component.getTitle(row)}}</p>
        </div>
      </template>
    </display-container>

    <div class="crtn_top">
      <div class="inner">
        <p class="title">Featured News</p>
        <div class="sect left">
          <display-container :section="421">
            <template v-slot="{ component, row }">
              <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
              <div class="txt">
              <p class="subj">{{component.getTitle(row)}}</p>
              <p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
              </div>
            </template>
          </display-container>
        </div>
        <div class="sect right">
          <display-container :section="422">
            <template v-slot="{ component, row }">
              <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
              <div class="txt">
              <p class="subj">{{component.getTitle(row)}}</p>
              <p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
              </div>
            </template>
          </display-container>
        </div>
      </div>
    </div>

    <sub-page-layout show-top-banner>

      <div class="title">
        <h3>Latest News</h3>
        <drop-down title="Categories" :data="getActiveCategories" key-name="idx" value-name="name" :action="clickDrowdownRow"></drop-down>
      </div>
      <ul class="lst" id="lst">
        <li v-for="(post, index) in getLatestPosts.data" :key="index" :class="{ 'has_banner': showSubMiddleBanner(index) }">

          <div v-if="showSubMiddleBanner(index)" class="banner">
            <display-container :section="311" empty-bg-color="transparent">
              <template v-slot="{ component, row }">
                <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
              </template>
            </display-container>
            <!--<ins class="adsbygoogle"
             style="display:block"
             data-ad-client="ca-pub-5310971739125617"
             data-ad-slot="1019921057"
             data-ad-format="auto"
             data-full-width-responsive="true"></ins>-->
          </div>

          <post-container :post="post"></post-container>
        </li>
      </ul>
      <a class="lst_no" v-if="!getLatestPosts.loading && getLatestPosts.total < 1">Did not match any articles</a>
      <a class="lst_more" :disabled="getLatestPosts.loading" v-if="!isLatestPostsFinish && getLatestPosts.total > 0" @click="getMoreLatestPosts()">Load More Articles</a>

    </sub-page-layout>

  </page-layout>
</template>

<script>
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import PostContainer from '../components/PostContainer'
  import DropDown from '../components/Dropdown'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import { mapGetters } from 'vuex'
  export default {
    name: 'News',
    components: {
      PageLayout,
      SubPageLayout,
      DisplayContainer,
      PostContainer,
      DropDown
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | Poker News`,
        titleTemplate: '%s',
        meta: [
          {vmid: 'description', name: 'description', content: `Latest news, event info, interviews, industry issues, rankings and strategy`},
          {vmid: 'image', name: 'image', content: '/statics/seo/seo_main.jpg'},
          {vmid: 'og:title', property: 'og:title', content: `Poker News | ${this.getAppName}`},
          {vmid: 'og:description', property: 'og:description', content: `Latest news, event info, interviews, industry issues, rankings and strategy`},
          {vmid: 'og:image', property: 'og:image', content: '/statics/seo/seo_main.jpg'}
        ]
      }
    },
    data () {
      return {
      }
    },
    mounted () {
      this.$store.dispatch('callCategories')
      this.$store.dispatch('callLatestPosts')
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'getActiveCategories',
        'getLatestPosts',
        'isLatestPostsFinish',
        'isExistDisplaySubMiddleBanner'
      ]),
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      }
    },
    methods: {
      ...CommonMethods,
      getMoreLatestPosts () {
        this.$store.dispatch('loadLatestPosts')
      },
      clickDrowdownRow (row) {
        this.$router.push({path: `/news/cate/${row.idx}`})
      },
      showSubMiddleBanner (index) {
        return index > 0 && index%6===0 && this.isMobile && this.isExistDisplaySubMiddleBanner
      }
    }
  }
</script>

<style scoped>
  .contents {
    position: relative;
    top: -40px;
  }
  .display-container.title {
    background: url(/statics/img/bg_sub_title.jpg) center no-repeat;
    background-size: cover;
    margin-bottom: 50px;
  }
  .title_top {
    position: relative;
    width: 1220px;
    height: 180px;
    display: flex;
    align-items: center;
    margin: 0 auto;
  }
  .title_top:before {
    content: "";
    display: inline-block;
    width: 54px;
    height: 54px;
    background: url(/statics/img/bi_white.png) center no-repeat;
    background-size: cover;
    margin-right: 15px;
  }
  .title_top p {
    font-family: 'Roboto Slab';
    font-size: 60px;
    font-weight: 900;
    color: #fff;
    line-height: 1.0em;
    text-transform: capitalize;
    z-index: 1;
  }
  .crtn_top .title {
    font-family: 'Roboto Slab';
    font-size: 28px;
    font-weight: 900;
    color: #000;
    margin: 0px 0 20px;
    letter-spacing: -0.02em;
  }
  .crtn_top .title:before {
    content: "";
    display: inline-block;
    width: 30px;
    height: 33px;
    background: url('/statics/img/bi_title.png') no-repeat;
    background-size: contain;
    margin-right: 14px;
  }
  .crtn_top .sect {
    display: inline-block;
    width: 50%;
  }
  .crtn_top .sect /deep/ a {
    border-radius: 8px;
  }
  .crtn_top .sect.left {
    padding-right: 19px;
    border-right: 1px solid #e5e5e5;
  }
  .crtn_top .sect.right {
    padding-left: 20px;
  }
  .crtn_top .sect .display-container {
    width: 100%;
  }
  .crtn_top .sect .display-container .img {
    height: 380px;
    width: 80%;
  }
  .crtn_top .sect .display-container .img img {
    transform: translate(-57%, -50%);
  }
  .crtn_top .sect .display-container .txt {
    position: absolute;
    top: 0;
    right: 0;
    width: 60%;
    height: 380px;
    background: linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,1.0) 50%);
    padding: 50px 30px 50px 80px;
  }
  .crtn_top .sect .display-container .subj {
    font-size: 26px;
    font-weight: 600;
    color: #fff;
    text-align: right;
    letter-spacing: -0.02em;
    word-break: normal;
  }
  .crtn_top .sect .display-container .category {
    font-size: 14px;
    font-weight: 600;
    color: #368ee9;
    line-height: 1.05em;
    margin-top: 18px;
    position: absolute;
    right: 30px;
    bottom: 50px;
  }
</style>
